import React from 'react';
import PropTypes from 'prop-types';
import { Colors } from '@common/tokens';
import { Icon } from '@common/components';

export function ExpiredComplianceBadges({
  expiredCount,
  expiringSoonCount,
  pendingVerificationCount,
}) {
  return (
    <div className="ComplianceBadges">
      {(expiredCount > 0 || expiringSoonCount > 0) && (
        <Icon
          icon="exclamationTriangle"
          kind="solid"
          size="sm"
          className="warning-icon"
        />
      )}
      {expiredCount > 0 && (
        <span className="expired">{expiredCount} Expired</span>
      )}
      {expiringSoonCount > 0 && (
        <span className="expiring">{expiringSoonCount} Expiring</span>
      )}
      {pendingVerificationCount > 0 && (
        <>
          <Icon icon="circle" kind="solid" size="sm" className="pending-icon" />
          <span>{pendingVerificationCount} Pending Verification</span>
        </>
      )}
      <style jsx>
        {`
          .expired,
          .expiring {
            padding-right: 6px;
          }
          .ComplianceBadges :global(.pending-icon) {
            color: ${Colors.sunDarker};
            padding-right: 6px;
          }
          .ComplianceBadges :global(.warning-icon) {
            color: ${Colors.coral};
            padding-right: 6px;
          }
        `}
      </style>
    </div>
  );
}

ExpiredComplianceBadges.propTypes = {
  expiredCount: PropTypes.number,
  expiringSoonCount: PropTypes.number,
  pendingVerificationCount: PropTypes.number,
};

ExpiredComplianceBadges.defaultProps = {
  expiredCount: 0,
  expiringSoonCount: 0,
  pendingVerificationCount: 0,
};
